<template>
  <div class="help-container">
     <!-- Loader -->
     <div v-if="loading">
      <div class="centered">
        <div class="horizontal-loader">
          <div class="loader-bar"></div>
        </div>
        <div class="loading-message">{{ messages || 'Loading...' }}</div>
      </div>
    </div>
    <div v-else-if="error" class="error">
      <p>Error: {{ error }}</p>
    </div>
    <div v-else class="help-content" v-html="htmlContent"></div>
  </div>
</template>
 
<script>
  import { get } from '@/utils/api'
  import { isAiMethodBedrock, isAiMethodTextract } from '../../utils/tenantUtils.js'
export default {
 
  name: 'Help',
  data() {
    return {
      htmlContent: '',
      loading: true,
      error: null,
      messages:"Loading help documentation…"
    }
  },
  mounted() {
    // Check if opened from new tab by Help button
    const isNewTab = window.opener !== null
   
    if (isNewTab) {
      // We're in the new tab - render the help content here
      this.fetchHelpContent()
    } else {
      // We're in the original tab - open new tab and go back
      this.openHelpInNewTab()
    }
  },
  methods: {
    openHelpInNewTab() {
      // Get current tenant name from route
      const tenantName = this.$route.params.tenantName
      const helpUrl = `${window.location.origin}/${tenantName}/help`
     
      // Open the Help page in a new tab
      window.open(helpUrl, '_blank')
     
      // Go back to previous page
      this.$router.back()
    },
    async getAIMethod () {
      if(await isAiMethodBedrock()){
        return 'bedrock'
      }else if (await isAiMethodTextract()){
        return 'textract'
      }else{
        return 'comprehend'
      }
    },
    async fetchHelpContent() {
      try {
        this.loading = true
        this.error = null
       
        // Fetch HTML content from protected backend API
        const aiMethod = await this.getAIMethod()
        console.log("aiMethod===>", aiMethod);
        
        const response = await get(`/v1/help/content?aiMethod=${aiMethod}`)
       
        if (!response.data) {
          throw new Error(`Failed to load help: ${response.statusText}`)
        }
       
        let htmlContent = response.data.htmlContent
        const baseUrl = window.location.origin
       
        // Replace all relative paths with absolute frontend public paths
        // Handle ./asset/, asset/ patterns
        htmlContent = htmlContent.replace(/src="\.\/asset\//g, `src="${baseUrl}/help/${aiMethod}/asset/`)
        htmlContent = htmlContent.replace(/src="asset\//g, `src="${baseUrl}/help/${aiMethod}/asset/`)
        htmlContent = htmlContent.replace(/href="\.\/style\.css"/g, `href="${baseUrl}/help/${aiMethod}/style.css"`)
        htmlContent = htmlContent.replace(/href="style\.css"/g, `href="${baseUrl}/help/${aiMethod}/style.css"`)
       
        // Check if in new tab (opened via window.open)
        const isNewTab = window.opener !== null
        if (isNewTab) {
          // Wrap in full HTML document for new tab display
          const fullHtml = `<!DOCTYPE html>
                              <html>
                              <head>
                              <meta charset="UTF-8">
                              <meta name="viewport" content="width=device-width, initial-scale=1.0">
                              <title>Help Documentation</title>
                              <style>
                              body {
                                font-family: Arial, sans-serif;
                                line-height: 1.6;
                                padding: 20px;
                                max-width: 1200px;
                                margin: 0 auto;
                              }
                              img { max-width: 100%; height: auto; }
                              </style>
                              </head>
                              <body>
                            ${htmlContent}
                            </body>
                            </html>`
          // Write to new tab document
          document.write(fullHtml)
          document.close()
        } else {
          // In Vue component - store for v-html rendering
          this.htmlContent = htmlContent
          this.loading = false
        }
      } catch (err) {
        this.error = err.message
        console.error('Error loading help content:', err)
        this.loading = false
      }
    }
  }
}
</script>
 
<style scoped>
.help-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
}
 
.loading, .error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  text-align: center;
}
 
.error {
  color: #d32f2f;
}
 
.help-content {
  max-width: 900px;
  margin: 0 auto;
}
 
.centered {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 300px;
}
 
.horizontal-loader {
  width: 200px;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 22px;
  margin-top: -200px;
}
.loader-bar {
  height: 100%;
  width: 40%;
  background-color: #164863;
  animation: slide 1s linear infinite;
  border-radius: 4px;
}
.loading-message {
  font-size: 1.13rem;
  color: #164863;
  text-align: center;
  font-weight: 600;
}
@keyframes slide {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(50%);
  }
  100% {
    transform: translateX(200%);
  }
}
</style>
 
 